import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["block", "children", "classes", "color", "size"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { cssUtils } from "../internal/CssUtils";
import styles from './SvgIcon.css';
var cx = classNames.bind(styles);
export var SvgIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx;

  var block = _ref.block,
      children = _ref.children,
      classes = _ref.classes,
      color = _ref.color,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    className: cx(classes === null || classes === void 0 ? void 0 : classes.root, (_cx = {
      block: block
    }, _defineProperty(_cx, "size_".concat(size), size), _defineProperty(_cx, "".concat(cssUtils("color_".concat(color))), color), _cx)),
    ref: ref
  }), children);
});
export default SvgIcon;